import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { EquipoService } from '../../services/equipo.service';
interface RelatedIds {
  id: number;
  id_next: number | null;
  id_prev: number | null;
}

@Component({
  selector: 'app-equipo-persona',
  templateUrl: './equipo-persona.component.html',
  styleUrls: ['./equipo-persona.component.css']
})
export class EquipoPersonaComponent implements OnInit {

  person: number = 0

  persona: any = {}
  prevNext: any = {}
  img: any;
  teamMembers: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,

    private equipoService: EquipoService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
      this.person = +params['id']
    });
  }

  ngOnInit(): void {

    // Primero obtenemos la lista de miembros del equipo
    this.equipoService.getTeamMembersItems().subscribe(
      (resp) => {
        this.teamMembers = resp.data.teammates.rows; // Aquí guardamos la lista de miembros en el servicio
        // Luego obtenemos el miembro del equipo específico
        this.equipoService.getTeamMember(this.person).subscribe(
          (resp) => {
            this.persona = resp.data.teammate
            // Aquí agregamos id_prev e id_next a persona
            const relatedIds = this.createNextPrev(this.persona.id);
            if (relatedIds) {
              this.persona.id_prev = relatedIds.id_prev;
              this.persona.id_next = relatedIds.id_next;
            }

            if (this.persona.imgBigUrl) {
              this.img = 'https://' + this.persona.imgBigUrl
            }
            this.titleService.setTitle('Equipo - RetailCo: ' + this.persona.name);
          },
          (error) => {
            console.error("Error al obtener el miembro del equipo: ", error);
          }
        );
      },
      (error) => {
        console.error("Error al obtener la lista de miembros del equipo: ", error);
      }
    );


  }

  createNextPrev(id: number): RelatedIds | null {
    const index = this.teamMembers.findIndex(member => member.id === id);

    if (index === -1) {
      return null; // El miembro con el id proporcionado no existe
    }

    const relatedIds: RelatedIds = {
      id: id,
      id_prev: index > 0 ? this.teamMembers[index - 1].id : null,
      id_next: index < this.teamMembers.length - 1 ? this.teamMembers[index + 1].id : null
    };

    return relatedIds;
  }

}
